import { render, staticRenderFns } from "./FSIoperationCockpit.vue?vue&type=template&id=06b2f11f"
import script from "./FSIoperationCockpit.vue?vue&type=script&lang=js"
export * from "./FSIoperationCockpit.vue?vue&type=script&lang=js"
import style0 from "./FSIoperationCockpit.vue?vue&type=style&index=0&id=06b2f11f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports